// redux
import store from '../../redux/store';

const repoRentalPermission = (
  {is_superuser = false, can_repo_vehicle_permission = false} = store.getState()
    .authorization.userData
) => is_superuser || can_repo_vehicle_permission;

export default repoRentalPermission;
